import { TPatientFollowupDocument } from 'src/pages/patients/patient-file/patient-followup/_components/patient-forms/use-patient-followup-documents.hook'
import { usePatientFollowupDocumentDisplay } from 'src/pages/patients/patient-file/patient-followup/_components/patient-forms/use-patient-followup-document-display.hook'
import { DocumentName } from './document-name.component'
import { DocumentStatusPill } from './document-status-pill.component'
import { DocumentSubtitle } from './document-subtitle.component'

interface PatientFollowupDocumentRowProps {
  document: TPatientFollowupDocument
}

const PatientFollowupDocumentRow = ({ document }: PatientFollowupDocumentRowProps) => {
  const { name, statusLabel, dateLabel, isAvailable } = usePatientFollowupDocumentDisplay(document)

  return (
    <div className="c-flex c-items-start c-gap-2">
      <DocumentStatusPill label={statusLabel} isAvailable={isAvailable} />
      <div className="c-flex c-flex-col c-gap-1">
        <DocumentName>{name}</DocumentName>
        {dateLabel && <DocumentSubtitle>{dateLabel}</DocumentSubtitle>}
      </div>
    </div>
  )
}

export { PatientFollowupDocumentRow }
